// extracted by mini-css-extract-plugin
export var container = "_2g-0";
export var disabled = "_2g-4";
export var fullWidth = "_2g-3";
export var lined = "_2g-1";
export var selected = "_2g-5";
export var tab = "_2g-2";